import React, { Component, Suspense } from 'react'

import ReactLoadingSkeleton from '../ReactLoadingSkeleton'

interface SuspenseWithLoaderProps {
   children: React.ReactNode
}

class SuspenseWithLoader extends Component<SuspenseWithLoaderProps> {
   render() {
      const { children } = this.props

      return (
         <Suspense
            fallback={
               <ReactLoadingSkeleton
                  loaderType={'ROUTE'}
                  pathname={window.location.pathname}
               />
            }
         >
            {children}
         </Suspense>
      )
   }
}

export default SuspenseWithLoader
